import React from "react";
import "./SelectInputField.scss"; // Make sure this path matches your file structure

const SelectInputField = ({ label, id, name, value, onChange, options }) => {
  return (
    <div className="select-input-field">
      {label && <label htmlFor={id}>{label}</label>}
      <select id={id} name={name} value={value} onChange={onChange}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectInputField;
